<template lang="pug">
fieldset.select-wrapper
  select(:id="id", :name="name", @change="updateValue")
    template(v-for="(option, index) in options")
      option(:value="option.value", :key="index")
        | {{ option.label }}
</template>

<script>
export default {
  name: "FormSelect",
  props: {
    value: { type: String, required: true },
    options: { type: Array, required: true },
    name: { type: String, required: true },
    id: { type: String, required: true },
  },
  methods: {
    updateValue: function (e) {
      const id = this.id;
      const result = { id: id, bool: false, message: "" };
      const options = this.options.map((item) => item.value);
      const value = e.target.value;
      if (id === "prefecture") {
        if (value === "") {
          result.message = "都道府県が選択されていません";
        } else if (!options.includes(value)) {
          result.message = "都道府県の値が不正です";
        } else {
          result.bool = true;
        }
      }

      if (id === "birthYear") {
        if (value === "") {
          result.message = "生まれ年が選択されていません";
        } else if (!options.includes(parseInt(value))) {
          result.message = "生まれ年の値が不正です";
        } else {
          result.bool = true;
          // GTMで利用するためにバリデーション通過後の値をdataLayer変数として格納
          const currentYear = new Date().getFullYear();
          // GTMで比較する際に文字列比較のため文字列に変換
          const isOverSixty = currentYear - value >= 60 ? "1" : "0";
          sessionStorage.setItem("isOverSixty", isOverSixty);
        }
      }

      this.$emit("checkValidate", result);
      this.$emit("input", value);
    },
  },
  created() {
    const id = this.id;
    if (id === "prefecture") {
      this.$emit("input", "都道府県を選択してください");
    } else if (id === "birthYear") {
      this.$emit("input", "生まれた年を選択してください");
    }
  },
};
</script>
